// src/hooks/useZustand.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { fromModuleStore, useModuleStore } from 'stores/module';
import { fromAppStore, useAppStore } from 'stores/app';
import { fromBootStore, useBootStore } from 'stores/boot';
import { fromGlobalStore, useGlobalStore } from 'stores/global';
import { fromThemeStore, useThemeStore } from 'stores/theme';
import { fromAuthStore, useAuthStore } from 'stores/auth';
import { fromTourStore, useTourStore } from 'stores/tour';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// HOOKS
// *******************************************************************************
const useZustand = (storeKey, stateKey = '', isReactComponent = true, fullLoadingObj = false) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. HOOKS & REFS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const stores = getStores();
  const store = stores[storeKey];
  const selector = stateKey ? s => s[stateKey] : s => s;
  const accessMethod = isReactComponent ? store.react : store.function;

  // ─────────────────────────────────────────────────────────────────────────────
  // 4. LOCAL STATE
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 5. EFFECTS I
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. EFFECTS II
  // ─────────────────────────────────────────────────────────────────────────────

  // ─────────────────────────────────────────────────────────────────────────────
  // 9. UI
  // ─────────────────────────────────────────────────────────────────────────────
  let result;

  if (
    storeKey === 'boot' &&
    ['loadingApp', 'loadingModule', 'loadingPage', 'loadingArea'].includes(stateKey) &&
    !fullLoadingObj
  ) {
    result = accessMethod(selector).visible;
  } else {
    result = accessMethod(selector);
  }

  // Fallback for global store contexts that don't exist yet
  // Return an empty object for destructuring safety
  if (
    storeKey === 'global' &&
    stateKey &&
    !['setState', 'state'].includes(stateKey) &&
    (result === null || result === undefined)
  ) {
    return {};
  }

  return result;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default useZustand;

// *******************************************************************************
// HELPERS
// *******************************************************************************
function getStores() {
  return {
    boot: {
      react: useBootStore,
      function: fromBootStore,
    },
    app: {
      react: useAppStore,
      function: fromAppStore,
    },
    auth: {
      react: useAuthStore,
      function: fromAuthStore,
    },
    theme: {
      react: useThemeStore,
      function: fromThemeStore,
    },
    module: {
      react: useModuleStore,
      function: fromModuleStore,
    },
    tour: {
      react: useTourStore,
      function: fromTourStore,
    },
    global: {
      react: useGlobalStore,
      function: fromGlobalStore,
    },
  };
}
